import React,{useState,useEffect} from 'react'
import {useParams} from 'react-router-dom'
import "../styles/PProject.css";
import projects from './Data';
import PacmanLoader	 from "react-spinners/PacmanLoader";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
  marginTop:"21rem",
};

function PProject() {

    let {projectName} = useParams();
  let [loading, setLoading] = useState(true);
    // console.log(projectName);
    // console.log(projects);
    useEffect(()=>{
      setTimeout(()=>{
          setLoading(false);
      },1200)
  })


    let project = projects.find((p)=>{
        return p.title === projectName;
    })
    console.log(project);
    const src1 = `/${project.image}`;
    let colors= [
      { name: "pink", color: "#E91E63" },
        { name: "purple", color: "#9C27B0" },
        { name: "deeppurple", color: "#673AB7" },
        { name: "indigo", color: "#3F51B5" },
        { name: "blue", color: "#2196F3" },
        { name: "lightblue", color: "#03A9F4" },
        { name: "cyan", color: "#00BCD4" },
        { name: "teal", color: "#009688" },
        { name: "green", color: "#4CAF50" },
        { name: "lightgreen", color: "#8BC34A" },
        { name: "lime", color: "#CDDC39" },
        { name: "yellow", color: "#FFEB3B" },
        { name: "amber", color: "#FFC107" },
        { name: "orange", color: "#FF9800" },
        { name: "deeporange", color: "#FF5722" },
        { name: "brown", color: "#795548" },
        { name: "grey", color: "#9E9E9E" },
        { name: "bluegrey", color: "#607D8B" }
    ]
    const randomColor =()=>{
      return colors[Math.floor(Math.random() * colors.length)].color;
    }

  return (
    <div className='PProject'>
       {loading ?  <PacmanLoader color={"#feb800"} loading={true} cssOverride={override} size={25}/>
                    :
                    <>
      {/* Navbar Starts */}
      <div className="PProject__navbar">
        <div className="PProject__navbar__left">
          <h1 className="PProject__navbar__left__heading">{projectName}</h1>
            </div>
            <div className="PProject__navbar__right">
              <a href="/projects" className="PProject__navbar__right__link btn" style={{marginTop:0}}>Go Back</a>
              </div>
        </div>
        {/* Navbar Ends */}
        <hr />
        {/* Hero Section */}
        <div className="PProject__heroSection">
        
                     <div className='PProject__container' >
                <div className='PProject__header'>
                    <div className='Ribbon'>
                        <span style={{backgroundColor:"#e43f52"}}/>
                        <span style={{backgroundColor:"#f17425"}}/>
                        <span style={{backgroundColor:"#2eca8b"}}/>
                    </div>
                    {/* <div className='Project__title'>
                        {project.title}
                    </div> */}
                </div>
                <div className='PProject__box'>

            <img src={src1} alt={project.image}/>
                
                </div>

                
            </div>
          {/* </div> */}
        </div>
        {/* Hero Section Ends */}
        <div className='PProject__link'>
          <a href={project.link} target="_blank" rel="noreferrer">
          <svg class="i-svg" height="25" version="1.1" width="25" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50" space="preserve" data-icon="facebook,"><path d="M36.999,36.998H13V13.089L19,13V7h-12v35.998h35.998V27.999h-6V36.998z M25,7l6,6l-9,9l6,6l8.999-9l6,6V7H25z" fill="#ffffff"></path></svg>
            Visit the Website
          </a>
        </div>

        {/* About */}
        <div className='PProject__About'>
              <h2>
                About this Project
              </h2>
              <hr/>
              <p>
                {project.description}
              </p>
        </div>
        {/* About Section Ends */}

        {/* Features Section */}
        <div className='PProject__Features'>
              <h2>Features</h2>
          <ul>
         {project.features.map(feature=><li>{feature}</li>)}
          </ul>  
        </div>
        {/* Features Section  Ends*/}
        {/* Technologies Used */}
        <div className='PProject__Technology'>
        <h2>Technologies Used</h2>
            <div className='Technologies'>
            {project.technology.map(tech=><span style={{backgroundColor:randomColor()}}>{tech}</span>)}
            </div>
        </div>
        {/* Technologies Used Ends */}
        <footer>
          <h4>Let's talk</h4>
          <p>Wanna get in touch or talk about a project?<br/>
Feel free to contact me via email at 
<b>  yadavjayant2003@gmail.com</b><br/>

or drop a line in the form at the<b> 
<a href="/contact" className='footer__link'>  contact page</a></b></p>
        </footer>
        </>
 }
    </div>
  )
}

export default PProject;
